import { Accessibility } from "lucide-react";

export const AccessibilityIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0052 2.16406C7.02617 2.16406 2.17188 7.01836 2.17188 12.9974C2.17188 18.9764 7.02617 23.8307 13.0052 23.8307C18.9842 23.8307 23.8385 18.9764 23.8385 12.9974C23.8385 7.01836 18.9842 2.16406 13.0052 2.16406ZM13.0052 4.08108C17.9264 4.08108 21.9218 8.07617 21.9218 12.9974C21.9218 17.9186 17.9264 21.9137 13.0052 21.9137C8.08423 21.9137 4.08889 17.9186 4.08889 12.9974C4.08889 8.07617 8.08423 4.08108 13.0052 4.08108Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4146 12.4593C11.2276 14.6079 10.7348 16.6917 9.96656 18.7178C9.77903 19.2125 10.0284 19.7662 10.5229 19.9538C11.0176 20.1413 11.5713 19.8921 11.7589 19.3974C12.3027 17.9631 12.7185 16.502 12.9975 15.0123C13.2765 16.502 13.6923 17.9631 14.2361 19.3974C14.4236 19.8921 14.9773 20.1413 15.4721 19.9538C15.9668 19.7662 16.216 19.2125 16.0284 18.7178C15.2607 16.6929 14.7681 14.6101 14.5808 12.4634C15.7289 12.407 16.8775 12.2867 18.0261 12.1001C18.5482 12.0151 18.9033 11.5223 18.8184 11.0001C18.7336 10.4782 18.2408 10.1231 17.7187 10.2079C14.5693 10.7197 11.4202 10.6995 8.27079 10.2069C7.74814 10.1253 7.25751 10.4833 7.17566 11.0059C7.09404 11.5286 7.45203 12.0192 7.97467 12.1008C9.12108 12.2802 10.2677 12.4005 11.4146 12.4593Z"
        fill={color}
      />
      <path
        d="M12.9956 9.78805C13.951 9.78805 14.7256 9.01352 14.7256 8.05809C14.7256 7.10266 13.951 6.32812 12.9956 6.32812C12.0402 6.32812 11.2656 7.10266 11.2656 8.05809C11.2656 9.01352 12.0402 9.78805 12.9956 9.78805Z"
        fill={color}
      />
    </svg>
    // <Accessibility
    //   stroke="var(--color-people-blue)"
    //   strokeWidth={1.5}
    // />
  );
};

export default AccessibilityIcon;